import type {
  AbilityData,
  ArtifactType,
  ItemData,
  ItemSourceView,
  NpcData,
  ObjectData,
  QuestData,
  QuestGiverView,
  RecipeData,
  ZoneData,
  ZoneLink,
} from '@thottbot/shared';
import { QuestFields } from './QuestFields';
import { ItemFields } from './ItemFields';
import { NpcFields } from './NpcFields';
import { ObjectFields } from './ObjectFields';
import { ZoneFields } from './ZoneFields';
import { AbilityFields } from './AbilityFields';
import { RecipeFields } from './RecipeFields';

/** Picks the per-type field table. `data` is the API's JSON object for the artifact. */
export function ArtifactFields({
  type,
  name,
  data,
  zone,
  questGivers,
  sources,
}: {
  type: ArtifactType;
  name: string;
  data: Record<string, unknown>;
  /** The artifact detail's zone link (NPCs and objects) for the spawn map. */
  zone?: ZoneLink;
  /** Quest-giving NPCs in this zone (zone pages). */
  questGivers?: QuestGiverView[];
  /** Where an item comes from (item pages). */
  sources?: ItemSourceView[];
}) {
  switch (type) {
    case 'quest':
      return <QuestFields data={data as QuestData} />;
    case 'item':
      return <ItemFields data={data as ItemData} sources={sources} />;
    case 'npc':
      return <NpcFields data={data as NpcData} name={name} zone={zone} />;
    case 'object':
      return <ObjectFields data={data as ObjectData} name={name} zone={zone} />;
    case 'zone':
      return <ZoneFields data={data as ZoneData} name={name} questGivers={questGivers} />;
    case 'ability':
      return <AbilityFields data={data as AbilityData} />;
    case 'recipe':
      return <RecipeFields data={data as RecipeData} />;
  }
}
